import { Validator } from '@vista-digital/validator';
import { defaultOrderExpiryCountdownAssets, orderExpiryCountdownAssetsValidator } from './assets';
import { defaultOrderExpiryCountdownDisplayText, orderExpiryCountdownDisplayTextValidator } from './display-text';
import { orderExpiryCountdownEventsValidator } from './events';
export const defaultOrderExpiryCountdownProps = {
    displayText: defaultOrderExpiryCountdownDisplayText,
    events: {},
    assets: defaultOrderExpiryCountdownAssets
};
export const orderExpiryCountdownPropsValidator = Validator.object({
    displayText: orderExpiryCountdownDisplayTextValidator,
    events: orderExpiryCountdownEventsValidator,
    assets: orderExpiryCountdownAssetsValidator
});
